import React, { useEffect, useState } from "react";
import dashboardStyle from "./dashboard.module.css";
import { AppBar, Box, MenuItem, Select, Tab, Tabs } from "@mui/material";
import { Skeleton } from "@mui/material";
import {
  ActiveCourseIcon,
  CopmletedCourseIcon,
  EnrolledCourseIcon,
  SearchIcon,
} from "../../svg";
import CourseCard from "../../component/CourseCard";
import FooterComponent from "../../component/FooterComponent";
import courseStyle from "../courses/courses.module.css";
import Messages from "./Messages";

import StudentSupportMessages from "./StudentSupportMessages";

import Notifications from "./Notifications";
import Settings from "./Settings";
import { useDispatch, useSelector } from "react-redux";
import api from "../helper/Api";
import Toastify from "../helper/Toastify";
import {
  getDashboardData,
  getPurchasedCourse,
  getWishlistCourse,
} from "../redux/dashboardSlice";
import { getProfile } from "../redux/userSlice";
import ErrorPage from "../../component/ErrorPage";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";

const StudentDashboard = () => {
  const dispatch = useDispatch();
  const dashboardData = useSelector((state) => state.dashboard);
  const isRefresh = useSelector((state) => state.dashboard.isRefresh);
  const isLoading = useSelector((state) => state.dashboard.isLoading);
  const userProfile = useSelector((state) => state.user);
  const getUserProfile = userProfile?.user;

  // Tab 0 - FIXED: Access data directly from purchasedCourseData
  const dashData = dashboardData?.dashboardData?.data;
  // Tab 1 - FIXED: Access the response data directly
const purchasedCourseData = dashboardData?.purchasedCourseData?.data || dashboardData?.purchasedCourseData;

  const [tabValue, setTabValue] = useState(0);
  const [search, setSearch] = useState("");
  const [order, setOrder] = useState("");
  const [filterBy, setFilterBy] = useState("");
  const [attendedWebinars, setAttendedWebinars] = useState([]);
  const [isAttendedLoading, setIsAttendedLoading] = useState(false);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleOrderChange = (event) => {
    const selectedId = event.target.value;
    setOrder(selectedId);
  };

  const handleStatusChange = (event) => {
    const selectedId = event.target.value;
    setFilterBy(selectedId);
  };

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getDashboardData());
  }, [dispatch]);

  // FIXED: Include includeRefunded parameter
  useEffect(() => {
    let data = {
      search,
      order,
      filterBy,
      sortBy: "createdAt",
      includeRefunded: true
    };
    dispatch(getPurchasedCourse(data));
  }, [dispatch, search, order, filterBy]);

  useEffect(() => {
    const fetchAttendedWebinars = async () => {
      if (tabValue !== 3) return;
      try {
        setIsAttendedLoading(true);
        const { data } = await api.getAttendedWebinars();
        setAttendedWebinars(data?.data || []);
      } catch (err) {
        Toastify.error(
          err?.response?.data?.message || "Failed to load attended webinars"
        );
      } finally {
        setIsAttendedLoading(false);
      }
    };

    fetchAttendedWebinars();
  }, [tabValue]);

  // FIXED: Data mapping with proper fallbacks
  const data = [
    {
      id: 0,
      icon: <EnrolledCourseIcon />,
      count: purchasedCourseData?.accessibleCourses || purchasedCourseData?.totalCourses || "0",
      name: "Enrolled Courses",
      status: "Enrolled",
    },
    {
      id: 1,
      icon: <ActiveCourseIcon />,
      count: purchasedCourseData?.activeCourses || "0",
      name: "Active Courses", 
      status: "Active",
    },
    {
      id: 2,
      icon: <CopmletedCourseIcon />,
      count: purchasedCourseData?.totalCompletedCourses || "0",
      name: "Completed Courses",
      status: "Completed",
    },
  ];
console.log("Full purchasedCourseData:", dashboardData?.purchasedCourseData);
console.log("Data field:", dashboardData?.purchasedCourseData?.data);
console.log("Courses array:", purchasedCourseData?.courses);

  return (
    <div>

      <StudentSupportMessages/>
      <div className={dashboardStyle.mainContainer}>
        <div className={dashboardStyle.dashContainer}>
          <div className={dashboardStyle.studentProfile}>
            {getUserProfile?.profileImg?.[0]?.length > 0 ? (
              <div>
                <img
                  src={getUserProfile?.profileImg?.[0]}
                  style={{
                    width: 60,
                    height: 60,
                    borderRadius: 30,
                    objectFit: "cover",
                  }}
                  alt="Avatar"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      "https://www.svgrepo.com/show/486506/user-profile-filled.svg";
                  }}
                />
              </div>
            ) : (
              <img
                src="https://www.svgrepo.com/show/486506/user-profile-filled.svg"
                alt="User Avatar"
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: 30,
                  objectFit: "cover",
                }}
              />
            )}
            <div>
              <p className={dashboardStyle.profileText}>
                {getUserProfile?.name}
              </p>
              <span>{getUserProfile?.email}</span>
            </div>
          </div>
          <div className={dashboardStyle.bottomLine} />
          <div className={dashboardStyle.tabsStyle}>
            <Box sx={{ overflowX: "auto", width: "100%" }}>
              <AppBar position="static" color="transparent" elevation={0}>
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  sx={{
                    width: "100%",
                    "& .MuiTabs-flexContainer": {
                      justifyContent: {
                        xs: "flex-start",
                        sm: "center",
                        md: "center",
                        lg: "center",
                      },
                      gap: { xs: "10px", sm: "10px", md: "20px", lg: "40px" },
                    },
                    "& .MuiTab-root": {
                      textTransform: "capitalize",
                      fontFamily: "Figtree",
                      fontSize: {
                        xs: "12px",
                        sm: "14px",
                        md: "16px",
                        lg: "18px",
                      },
                      fontWeight: "500",
                      lineHeight: "22px",
                      textAlign: "left",
                      color: "#6E7485",
                      paddingLeft: {
                        xs: "5px",
                        sm: "10px",
                        md: "15px",
                        lg: "25px",
                      },
                      "&.Mui-selected": {
                        color: "#1D2026",
                        fontWeight: "600",
                        "&.MuiTab-iconWrapper": {
                          color: "#1D83F8",
                        },
                      },
                    },
                    "& .MuiTabs-indicator": {
                      backgroundColor: "#1D83F8",
                      height: "2px",
                      width: "50px",
                      left: "calc(50% - 25px)",
                      transition: "left 0.3s ease",
                    },
                  }}
                >
                  <Tab label="Courses" />
                  <Tab label="Message" />
                  <Tab label="Notifications" />
                  <Tab label="Webinar Attended" />
                  <Tab label="Settings" />
                </Tabs>
              </AppBar>
            </Box>
          </div>
        </div>
      </div>
      {tabValue === 0 ? (
        <div className={dashboardStyle.tabContainer}>
          {/* FIXED: Use accessibleCourses with fallback to totalCourses */}
          <div className={dashboardStyle.headingText}>
            Course({purchasedCourseData?.accessibleCourses || purchasedCourseData?.totalCourses || "0"})
          </div>
          <div className={dashboardStyle.dasboardCardStyle}>
            {data.map((item, index) => (
              <div
                className={dashboardStyle.cardStyle}
                style={{
                  backgroundColor:
                    item.status === "Enrolled"
                      ? "#FFCDCD"
                      : item.status === "Active"
                      ? "#EBEBFF"
                      : "#E1F7E3",
                }}
                key={index}
              >
                <div className={dashboardStyle.iconStyle}>{item.icon}</div>
                <div>
                  <p>{item.count}</p>
                  <span>{item.name}</span>
                </div>
              </div>
            ))}
          </div>

          <div
            className={dashboardStyle.childCompoStyle}
            style={{ marginTop: 20 }}
          >
            <div className={dashboardStyle.searchStyle}>
              <label className={courseStyle.sortText}>Search</label>
              <div className={dashboardStyle.inputBox}>
                <SearchIcon />
                <input
                  type="text"
                  placeholder="Search Course"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
            <div className={dashboardStyle.sortByStyle}>
              <label className={courseStyle.sortText}>Sort by:</label>
              <div>
                <Select
                  IconComponent={ArrowDropDownIcon}
                  displayEmpty
                  defaultValue=""
                  name={"order"}
                  value={order || ""}
                  onChange={handleOrderChange}
                  sx={{
                    width: "100%",
                    height: "48px",
                    color: "#8D8D8D",
                    fontFamily: "Poppins",
                    lineHeight: "20px",
                    fontSize: "14px",
                    outline: "none !important",
                    padding: "20px",
                    borderRadius: "16px",
                    border: "1px solid var(--Gray-100, #E0E2E7) !important",
                    ".MuiSelect-select": {
                      padding: "12px 1px !important",
                    },
                    ".MuiOutlinedInput-notchedOutline": {
                      border: "none !important",
                    },
                  }}
                >
                  <MenuItem value="">Select</MenuItem>
                  <MenuItem value="desc">Latest</MenuItem>
                  <MenuItem value="asc">Oldest</MenuItem>
                </Select>
              </div>
            </div>
            <div className={dashboardStyle.sortByStyle}>
              <label className={courseStyle.sortText}>Status</label>
              <div>
                <Select
                  IconComponent={ArrowDropDownIcon}
                  displayEmpty
                  defaultValue=""
                  name={"filterBy"}
                  value={filterBy || ""}
                  onChange={handleStatusChange}
                  sx={{
                    width: "100%",
                    height: "48px",
                    color: "#8D8D8D",
                    fontFamily: "Poppins",
                    lineHeight: "20px",
                    fontSize: "14px",
                    outline: "none !important",
                    padding: "20px",
                    borderRadius: "16px",
                    border: "1px solid var(--Gray-100, #E0E2E7) !important",
                    ".MuiSelect-select": {
                      padding: "12px 1px !important",
                    },
                    ".MuiOutlinedInput-notchedOutline": {
                      border: "none !important",
                    },
                  }}
                >
                  <MenuItem value="">None</MenuItem>
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="completed">Completed</MenuItem>
                </Select>
              </div>
            </div>
          </div>
          
          {/* FIXED: Check for courses array properly */}
          {purchasedCourseData?.courses && purchasedCourseData.courses.length > 0 ? (
            <div
              className={dashboardStyle.dasboardCardStyle}
              role="region"
              aria-label="Course Cards"
            >
              <CourseCard
                data={purchasedCourseData.courses}
                isLoading={isLoading}
              />
            </div>
          ) : (
            <ErrorPage />
          )}
        </div>
      ) : tabValue === 1 ? (
        <div className={dashboardStyle.tabContainer} style={{ marginTop: 20 }}>
          <Messages />
        </div>
      ) : tabValue === 2 ? (
        <div className={dashboardStyle.tabContainer} style={{ marginTop: 20 }}>
          <div className={dashboardStyle.headingText}>Notifications</div>
          <Notifications />
        </div>
      ) : tabValue === 3 ? (
        <div className={dashboardStyle.tabContainer} style={{ marginTop: 20 }}>
          <div className={dashboardStyle.headingText}>Webinar Attended</div>
          {isAttendedLoading ? (
            <div className={dashboardStyle.dasboardCardStyle}>
              {[...Array(4)].map((_, index) => (
                <div className={dashboardStyle.webinarCardStyle} key={index}>
                  <Skeleton variant="rectangular" className={dashboardStyle.webinarImageView} />
                  <div className={dashboardStyle.webinarCardBody}>
                    <Skeleton variant="text" width="70%" height={28} />
                    <Skeleton variant="text" width="90%" />
                    <Skeleton variant="text" width="80%" />
                    <Skeleton variant="text" width="60%" />
                  </div>
                </div>
              ))}
            </div>
          ) : attendedWebinars?.length > 0 ? (
            <div className={dashboardStyle.dasboardCardStyle}>
              {attendedWebinars.map((item) => (
                <div key={item?._id} className={dashboardStyle.webinarCardStyle}>
                  <img
                    src={item?.webinarBanner?.[0] || "https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=800&q=60"}
                    className={dashboardStyle.webinarImageView}
                    alt={item?.title || "Webinar"}
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = "https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=800&q=60";
                    }}
                  />
                  <div className={dashboardStyle.webinarCardBody}>
                    <h6>{item?.title || "Webinar"}</h6>
                    <p>{item?.subtitle || "Attended webinar session"}</p>
                    <div className={dashboardStyle.lineStyle} />
                    <span>
                      Date: {item?.webinarDate ? new Date(item.webinarDate).toLocaleDateString() : "-"}
                    </span>
                    <span>
                      Time: {item?.webinarStartTime || "-"} - {item?.webinarEndTime || "-"}
                    </span>
                    <span>
                      Duration: {item?.attendance?.duration || 0} minutes
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <ErrorPage />
          )}
        </div>
      ) : tabValue === 4 ? (
        <div className={dashboardStyle.tabContainer} style={{ marginTop: 20 }}>
          <Settings getUserProfile={getUserProfile} />
        </div>
      ) : null}
      <div className={dashboardStyle.footerStyle}>
        <FooterComponent />
      </div>
    </div>
  );
};

export default StudentDashboard;